var themeContract = {
  argos: {
    policyLink: {
      color: 'brand-1'
    }
  },
  habitat: {
    policyLink: {
      color: 'grey-90'
    }
  },
  tu: {
    policyLink: {
      color: 'brand-1'
    }
  },
  nectar: {
    policyLink: {
      color: 'grey-90'
    }
  },
  sainsburys: {
    policyLink: {
      color: 'grey-90'
    }
  }
}; // eslint-disable-next-line import/prefer-default-export

export { themeContract };